import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { switchMap, map } from 'rxjs/operators';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

import {Customer, Source, Charge, SubscriptionPlan, StripeObject, SourceAddress} from './models';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { StateService } from 'app/core/state.service';
import {Plan, Product} from "../pages/checkit-dashboard/checkit.model";
import {AuthService} from "../core/auth.service";



@Injectable()
export class PaymentService {

    readonly api = `${environment.functionsURL}/app`;

    private stripe = Stripe(environment.stripePublishable);;
    elements: any;
    public planId:string;
    public planQty:number = 1;
    public products_loading = false;
    public products:any = {};
    public selected_product;
    public customer$;
    public customer;
    public subscription;
    public next_payment_attempt


    constructor(
        private http: HttpClient,
        private afAuth: AngularFireAuth,
        private afs: AngularFirestore,
        private state:StateService,
        private auth:AuthService
    ) {
        this.elements = this.stripe.elements();
        this.auth.user.subscribe(user=>{
            if(user) {
                console.log('called')
                this.customer$ = this.getCustomer();
                this.customer$.subscribe(customer=>{
                    this.customer = customer;
                    if(customer.subscriptions){
                        this.subscription = customer.subscriptions.data[0];
                    }
                    console.log('account customer = ',customer)
                    if(customer.hasOwnProperty('upcoming_invoice') && customer.upcoming_invoice.hasOwnProperty('next_payment_attempt')){
                        this.next_payment_attempt = customer.upcoming_invoice.next_payment_attempt;
                    }
                    this.informProducts();
                },error=>{
                    console.log('auth.user customer$ subscribe error: ',error)
                })
            }
        })
        // collect plans
        this.getPlans().subscribe((list:Array<Plan>) => {
            if(list){
                console.log('list ',list)
                list.forEach((plan:Plan)=>{
                    if(!this.products.hasOwnProperty(plan.currency)){
                        this.products[plan.currency] = [];
                    }
                    if(plan.billing_scheme == 'tiered' && plan.tiers){
                        plan.tiers.forEach(tier=>{
                            let product:Product = {
                                plan:plan.id,
                                quantity:tier.up_to,
                                frequency:plan.interval, // 'month'
                                rate:tier.amount/100,
                                label:"Live Events",
                                type:"subscription"}
                            this.products[plan.currency].push(product);
                        })
                    }
                })
                this.informProducts()
            }
            this.products_loading = false;
        });
    }

    informProducts(){
        if(this.products && this.subscription){
            console.log('informProducts succeed')
            console.log('p,s,' ,this.products, this.subscription)
            const curr = this.subscription.plan.currency;
            const prods = this.products[curr];
            if(!prods) return;
            for(let p = 0; p < prods.length; p++){
                if(prods[p].plan == this.subscription.plan.id && prods[p].quantity == this.subscription.quantity){
                    console.log('prods ',prods[p])
                    this.products[curr][p].is_current_plan = true;
                    this.selected_product = prods[p];
                }
            }
        }
    }

    ///// RETRIEVE DATA ////

    // Get customer data
    getCustomer(): Observable<Customer> {
        const url = `${this.api}/customer/`;
console.log('getCustomer call ')
        return this.http.get<Customer>(url);
    }

    // Get a list of charges
    getCharges(): Observable<Charge[]> {
        const url = `${this.api}/charges/`;

        return this.http.get<StripeObject>(url).map(res => res.data);
    }

    // Get a list of plans
    getPlans(): Observable<Plan[]> {
        this.products_loading = true;
        const url = `${environment.functionsURL}/getSubscriptionPlans/`;
        return this.http.get<Plan[]>(url);
    }


    ///// PAYMENT ACTIONS ////


    createCharge(card: any, amount: number): Observable<Charge> {
        const url = `${this.api}/charges/`;

        return fromPromise<Source>( this.stripe.createSource(card, {type:'card'}) ).pipe(
            switchMap(data => {
                return this.http.post<Charge>(url, { amount, sourceId: data.source.id })
            })
        )
    }

    // Saves a payment source to the user account that can be charged later
    attachSource(card: any, nameOnCard:string, address:SourceAddress = null, makeDefault:boolean = false): Observable<Source> {
        const url = `${this.api}/sources/`;

        return fromPromise<Source>( this.stripe.createSource(card, {type:'card', owner:{name:nameOnCard, address:address}}) ).pipe(
            switchMap(data => {
                return this.http.post<Source>(url, { sourceId: data.source.id, makeDefault:makeDefault })
            })
        )
    }

    removeSource(sourceId:string): Observable<Source> {

        const url = `${this.api}/sources/remove`;

        return this.http.post<Source>(url, { sourceId: sourceId })
    }

    makeSourceDefault(sourceId:string): Observable<Source> {

        const url = `${this.api}/sources/assign`;

        return this.http.post<Source>(url, { sourceId: sourceId })
    }

    ///// SUBSCRIPTION ACTIONS ////

    // Attaches subscription to user (Stripe will charge the source)
    attachSubscription(sourceId: string, planId: string, quantity: number): Observable<SubscriptionPlan> {
        const url = `${this.api}/subscriptions`;
        console.log('sourceId, planId, quantity ',sourceId, planId, quantity);
        console.log('accountId ',this.state.accounts['currentId']);
        const accountId = this.state.accounts['currentId'];
        return this.http.post<SubscriptionPlan>(url, { accountId, sourceId, planId, quantity });
    }

    // Cancels subscription
    cancelSubscription(accountId: string, planId: string): Observable<SubscriptionPlan> {
        const url = `${this.api}/subscriptions/cancel`;
        console.log('cancelSubscription');
        return this.http.put<SubscriptionPlan>(url, { accountId,  planId});
    }


}



// WEBPACK FOOTER //
// ./src/app/payment/payment.service.ts